import * as P from 'prop-types';

const propTypes = {
  open: P.bool.isRequired,
  close: P.func.isRequired,
};

export default {
  propTypes,
  defaultProps: {},
};
